import { Types } from "../actions/leaveAdjustmentActions";
import _ from "lodash";
import { NotificationManager } from "react-notifications";

const leaveAdjustmentReducers = (state, action) => {
	switch (action.type) {
		case Types.LEAVE_ADJUSTMENT_IMPORT_UPLOAD_TEMPLATE: {
			let newState = _.cloneDeep(state);
			newState.leaveAdjustmentImport.template = action.template;
			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_IMPORT_SHOW_MODAL: {
			let newState = _.cloneDeep(state);
			newState.leaveAdjustmentImport.showModal = action.status;
			if (!action.status) newState.leaveAdjustmentImport = { results: {} };
			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_FILE_UPLOADING: {
			let newState = _.cloneDeep(state);

			newState.leaveAdjustmentImport = {
				...newState.leaveAdjustmentImport,
				uploading: true,
			};

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_FILE_UPLOADED: {
			let newState = _.cloneDeep(state);

			newState.leaveAdjustmentImport = {
				...newState.leaveAdjustmentImport,
				uploading: false,
				uploadResults: action.key,
			};

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSING: {
			let newState = _.cloneDeep(state);
			newState.leaveAdjustmentImport.processingFile = action.key;
			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_IMPORT_DATA_PROCESSED: {
			let newState = _.cloneDeep(state);
			newState.leaveAdjustmentImport.results = {
				processed: action.processed,
				errors: action.errors,
				warnings: action.warnings,
			};
			newState.leaveAdjustmentImport.processingFile = null;
			return newState;
		}

		case Types.LEAVE_ADJUSTMENT_UPDATE: {
			let newState = _.cloneDeep(state);

			newState.leaveAdjustments.adjustments = action.data;

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_OPEN_MODAL: {
			let newState = _.cloneDeep(state);

			newState.leaveAdjustments = { ...newState.leaveAdjustments };

			console.log("action", action);
			newState.leaveAdjustments.modalAdjustmentState = action.status;
			newState.leaveAdjustments.modalAdjustmentLeave = action.leaveAdj;

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_CANCEL: {
			let newState = _.cloneDeep(state);

			newState.leaveAdjustments.showCancelLeave = action.leaveAdj;
			newState.leaveAdjustments.showCancelLeaveStatus = action.status;

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_SHOW_COMMENTS: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.leaveAdjustments.showComments = action.leaveAdjustments;

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_SHOW_ATTACHMENTS: {
			let newState = _.cloneDeep(state);

			console.log("action", action);
			newState.leaveAdjustments.showAttachments = action.leaveAdjustments;

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_SAVING: {
			let newState = _.cloneDeep(state);

			newState.leaveAdjustments.modalSaving = action.id ? true : false;
			newState.leaveAdjustments.saving = { ...newState.leaveAdjustments.saving } || [];
			newState.leaveAdjustments.saving[action.id] = true;

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_SAVE_CURRENT: {
			let newState = _.cloneDeep(state);

			const myIndex =
				newState.leaveAdjustments &&
				newState.leaveAdjustments.adjustments &&
				newState.leaveAdjustments.adjustments.findIndex((item) => item.id == action.payload.leaveAdjustment.id);
			if (myIndex >= 0) {
				newState.leaveAdjustments.adjustments[myIndex] = {
					...newState.leaveAdjustments.adjustments[myIndex],
					...action.payload.leaveAdjustment,
				};
			} else if (newState.leaveAdjustments && newState.leaveAdjustments.adjustments) {
				console.log("addToMyLeave", action.payload.leaveAdjustment);
				newState.leaveAdjustments.adjustments.push(action.payload.leaveAdjustment);
				newState.leaveAdjustments.adjustments = _.orderBy(
					newState.leaveAdjustments.adjustments,
					["start"],
					["desc"],
				);
			}

			// clear files in case of uploads
			newState.leaveAdjustments.filesUploaded = [];

			// console.log('TIMESHEET_SAVED',action)
			newState.leaveAdjustments.modalSaving = false;

			newState.leaveAdjustments.saving = { ...newState.leaveAdjustments.saving };
			delete newState.leaveAdjustments.saving[action.payload.leaveAdjustment.id];

			newState.leaveAdjustments.leaveAdjustmentsSaved = true;
			newState.leaveAdjustments.modalAdjustmentState = false;

			NotificationManager.success(`Your Leave Adjustment has been saved`, "Success");

			return newState;
		}
		case Types.LEAVE_ADJUSTMENT_REPORT_DOWNLOADING: {
			let newState = _.cloneDeep(state);

			newState.leaveAdjustments.reportDownloading = action.status;

			return newState;
		}
		default:
			return state;
	}
};

export default leaveAdjustmentReducers;
